export default __webpack_public_path__ + "static/media/anglo-chinese-school-crest.7c318e04.png";